import script from "./TaskStatusBars.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskStatusBars.vue?vue&type=script&setup=true&lang=js"

import "./TaskStatusBars.vue?vue&type=style&index=0&id=91444bcc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91444bcc"]])

export default __exports__